import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, timeout, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { CmsTokenBridgeService } from './cms-token-bridge.service';
import { CMS_BYPASS_GUARD } from './cms-auth.tokens';
/**
 * Increased from 5s to 10s to accommodate federated (Entra ID) login flows
 * where the platform may need extra time to resolve the access token
 * before forwarding it to the CMS iframe via postMessage.
 */
const TOKEN_WAIT_MS = 10_000;
export const cmsAuthGuard: CanActivateFn = () => {
  const bypass = inject(CMS_BYPASS_GUARD);
  if (bypass) {
    return true;
  }
  const bridge = inject(CmsTokenBridgeService);
  const router = inject(Router);
  if (bridge.getToken()) {
    return true;
  }
  if (!bridge.isEmbedded()) {
    return router.parseUrl('/access-denied');
  }
  return bridge.waitForToken$().pipe(
    timeout(TOKEN_WAIT_MS),
    map(() => true),
    catchError(() => {
      console.warn('[CmsAuthGuard] Timed out waiting for SSO token.');
      return of(router.parseUrl('/access-denied'));
    })
  );
};
